import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDoubleColumn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 42,
	viewBox: "0 0 48 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 2C0 0.89543 0.895431 0 2 0H46C47.1046 0 48 0.895431 48 2V42H0V2Z",
			fill: "#F1F1F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 6C5 5.44772 5.44772 5 6 5H43C43.5523 5 44 5.44772 44 6V12C44 12.5523 43.5523 13 43 13H6C5.44772 13 5 12.5523 5 12V6Z",
			fill: "#DBD9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 16,
			width: 18,
			height: 6,
			rx: 1,
			fill: "#DBD9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 25,
			width: 18,
			height: 13,
			rx: 1,
			fill: "#DBD9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26,
			y: 16,
			width: 18,
			height: 5,
			rx: 1,
			fill: "#DBD9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26,
			y: 24,
			width: 18,
			height: 5,
			rx: 1,
			fill: "#DBD9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26,
			y: 32,
			width: 18,
			height: 5,
			rx: 1,
			fill: "#DBD9D9"
		})
	]
});
export default SvgIconDoubleColumn;
